import React, { useState } from "react";
import { LegacyCard as Card, Modal, BlockStack, InlineStack, Link, Thumbnail, Icon } from "@shopify/polaris";
import { StatusActiveIcon } from "@shopify/polaris-icons";
import PropTypes from "prop-types";

import constant from "lib/constant/constant";

// import components
import { DropZone } from "lib/components";
import { imageHelper } from "lib/helpers";

const Image = (props) => {
  const { setImage, productImages: images = [], image = [], cms, setDisabledButton } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});

  const onImageChange = (nImage) => {
    setSelectedImage(images.imageUrl === nImage.imageUrl ? false : nImage);
    setDisabledButton(false);
  };

  const uploadLocalImage = (value) => {
    const uploadImage = value;
    uploadImage.upload = constant.LOCAL;
    setImage(uploadImage);
  };

  const renderModal = () => {
    const allImages = images.filter((item) => item && item.imageUrl);
    const productImages = allImages.map((nImage, index) => {
      const isSelectedImage = nImage.imageUrl === selectedImage.imageUrl;
      return (
        <BlockStack inlineAlign="center" key={nImage.position}>
          <Link onClick={() => onImageChange(nImage)}>
            <Thumbnail
              source={imageHelper.resize({ url: nImage.imageUrl, type: constant.imageTypes.THUMBNAIL })}
              alt={`Image ${index}`}
              size="large"
            />
          </Link>
          {isSelectedImage && <Icon source={StatusActiveIcon} color="greenDark" backdrop />}
        </BlockStack>
      );
    });
    return <InlineStack>{productImages}</InlineStack>;
  };
  return (
    <Card
      title={cms("section.images.title")}
      id="variantImage"
      sectioned
      // actions={[
      //   {
      //     content: cms("section.image.modal.title"),
      //     onAction: () => setIsOpen(true),
      //   },
      // ]}
    >
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title={cms("section.image.modal.title")}
        primaryAction={{
          content: cms("section.label.button.save"),
          onAction: () => {
            setIsOpen(false);
            setImage([{ url: selectedImage.url }]);
          },
        }}
        sectioned
      >
        <Modal.Section>
          <Card sectioned>{renderModal()}</Card>
        </Modal.Section>
      </Modal>
      <DropZone
        id="dropZone"
        onAdd={(value) => {
          uploadLocalImage(value);
          setDisabledButton(false);
        }}
        onRemove={() => {
          setImage([]);
          setDisabledButton(false);
        }}
        fileList={(image && image.length && image) || []}
        allowMultiple={false}
        size={10}
      />
    </Card>
  );
};

Image.propTypes = {
  setImage: PropTypes.func.isRequired,
  productImages: PropTypes.arrayOf(PropTypes.shape).isRequired,
  image: PropTypes.arrayOf(PropTypes.any),
  cms: PropTypes.func.isRequired,
};

Image.defaultProps = {
  image: [],
};

export default Image;
